export default "__VITE_ASSET__BWizSRgO__"